import React from 'react';
import { bem, getDataAttr } from '../_libs/utils';
import { Component, PropTypes } from '../_libs';

export default class CommentText extends Component {
  render() {
    const displayName = 'comment';
    const { children, at } = this.props;
    return (
      <div
        style={this.style()}
        className={bem(displayName, 'txt')}
        {...getDataAttr(this.props)}>{at && <span className="at">回复{at}：</span>}{children}</div>
    );
  }
}

CommentText.defaultProps = {
  at: null,
  children: null,
};

CommentText.propTypes = {
  // @INTRO 回复人名
  at: PropTypes.string,
  // @INTRO 文本
  children: PropTypes.node,
};
